import { render, staticRenderFns } from "./gradePropertyCard.vue?vue&type=template&id=bff49cce"
import script from "./gradePropertyCard.vue?vue&type=script&lang=js"
export * from "./gradePropertyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports